import React, { useState } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import Table from '@/components/Table';
import { Notice, NoticeList } from '@/assets/data/noticeList';
import _ from 'lodash';
import { MAIN_NOTICE, neverSeeAgainState } from '@/recoil/neverSeeAgain';
import { useRecoilState } from 'recoil';
import { ReactComponent as MegaPhone } from '@/assets/images/common/megaPhone.svg';

const NoticePage = () => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [neverSeeAgain, setNeverSeeAgain] = useRecoilState(neverSeeAgainState);
  const sortedNoticeList = [...NoticeList].sort(i => (i.fixed ? -1 : 1));

  const headers = [
    { name: '번호', flex: 10, alias: 'count' },
    { name: '', flex: 10, alias: 'type' },
    { name: '제목', flex: 50, alias: 'title', left: true },
    { name: '작성자', flex: 20, alias: 'author' },
    { name: '작성일', flex: 20, alias: 'createdAt' }
  ];

  const rowDataFormat = (item: Notice, alias: string) => {
    switch (alias) {
      case 'count':
        return item.fixed ? <MegaPhone /> : item.id;
      case 'type':
        return titleFormat(item);
      case 'title':
        return item.title;
      case 'author':
        return item.author;
      case 'createdAt':
        return item.createdAt;
    }
  };
  const goDetailPage = (id: number, item?: Notice) => {
    if (!_.isEmpty(item)) {
      if (NoticeList.length === id) {
        setNeverSeeAgain({
          ...neverSeeAgain,
          lastestNotice: MAIN_NOTICE
        });
      }
      history.push(`/notice/${id}`);
    }
  };

  const titleFormat = (item: Notice) => (
    <Title>
      <Tag type={item.type}>
        {item.type === 'update' ? '업데이트' : '공지사항'}
      </Tag>
    </Title>
  );

  const highLightCheck = (item?: Notice) => {
    if (neverSeeAgain.lastestNotice !== MAIN_NOTICE) {
      return item?.id === NoticeList.length;
    }
    return false;
  };

  return (
    <Wrapper>
      <Table
        tableHeader={'공지사항'}
        data={sortedNoticeList}
        headers={headers}
        rowDataFormat={rowDataFormat}
        page={page}
        // 페이지 별 숫자 클릭시 동작을 안하고 있어 0으로 설정해버릴게요
        // totalCount={sortedNoticeList.length || 0}
        totalCount={0}
        setPage={setPage}
        itemsCountPerPage={10}
        onClick={goDetailPage}
        highLightCheck={highLightCheck}
      />
    </Wrapper>
  );
};

export default NoticePage;

const Wrapper = styled.div`
  width: 100%;

  ${({ theme }) => theme.media.threeQuarter`
    width: 100%;
  `};
`;

const Title = styled.div`
  display: inline-flex;
  align-items: center;
`;

const Tag = styled.div<{ type: string }>`
  padding: 6px 8px 5px;
  border-radius: 8px;
  font-weight: 700;
  margin-right: 15px;
  font-size: 13px;
  border: 1px solid
    ${({ type, theme }) =>
      type === 'update' ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.BLUE500};
  color: ${({ type, theme }) =>
    type === 'update' ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.BLUE500};
`;
